import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../../../redux';
import { loadGoal, deleteGoal } from '../../../redux';
import { Ability, Icon, Button } from '../../../components';

function GoalDelete() {
    const { t }    = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    let { id }     = useParams();

    const { goal, deleting, deleted } = useAppSelector((state: RootState) => state.goals);

    useEffect(() => {
        if (id)
            dispatch(loadGoal(id));
    }, [dispatch, id]);

    const doDelete = () => {
        dispatch(deleteGoal(goal._id));
    };

    if (deleted)
        navigate('/goals');

    return (
        <Ability can="goal:delete" redirect="/">
            <div className="GoalDelete">
                <header className="bg-white dark:bg-gray-800 border-b dark:border-gray-700 px-4 py-0 sm:px-6 lg:px-8">
                    <div className="my-2 mx-auto lg:flex lg:items-center lg:justify-between">
                        <div>
                            <h2 className="flex items-center text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
                                <Icon type="goal" size={7} />&nbsp;
                                { t('goals.delete_goal', {name: goal?.name}) }
                            </h2>
                        </div>
                    </div>
                </header>
                <main className="mx-6 my-6">
                    {goal && (goal._id === id) && (
                    <div className="flex">
                        <div className="w-fit mx-auto">
                            <h1 className="mx-auto font-bold p-2 mb-2">
                                { t('goals.sure_to_delete_goal', {name: goal?.name}) }
                            </h1>
                            <div className="mt-5 flex justify-evenly">
                                <Button title={t('common.cancel')} color="navigateBack" to={`/goals/${goal?._id}`} icon="back" />
                                <Button
                                    onClick={doDelete}
                                    title={t('common.delete')}
                                    icon="delete"
                                    loading={deleting === 'pending'}
                                    color="danger"
                                />
                            </div>
                        </div>
                    </div>
                    )}
                </main>
            </div>
        </Ability>
    );
}

export default GoalDelete;
